document.addEventListener('DOMContentLoaded', function() {
    const countdown = document.getElementById('countdown');

    if (countdown) {
        const date = countdown.dataset.countdownTo;
        const deadline = new Date(date).getTime();

        const x = setInterval(function() {
            const now = new Date().getTime();
            const t = deadline - now;
            // const days = Math.floor(t / (1000 * 60 * 60 * 24));
            // const hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((t % (1000 * 60)) / 1000);

            countdown.innerHTML = minutes + ':' + seconds.toString().padStart(2, '0');

            if (t < 0) {
                clearInterval(x);
                // countdown.innerHTML = 'EXPIRED';
                document.getElementById('deadline').innerHTML = 'Objednávka lístků propadla.';
            }
        }, 1000);
    }
});



// WEBPACK FOOTER //
// ./scripts/countdown.js